"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EProductTypeTrads = void 0;
exports.EProductTypeTrads = {
    scpi: "SCPI",
    private_equity: "Private Equity",
    natural_assets: "Actifs Naturels",
    diversification: "Diversification",
};
